export default {
  'build.info': 'Информация о сборке',
  'build.mode': 'Режим',
  'build.framework': 'Фреймворк',
  'build.os': 'Операционная система',
  'build.osPlatform': 'Платформа',
  'build.osRelease': 'Релиз',
  'theme.light': 'Светлая',
  'theme.dark': 'Тёмная',
  'theme.system': 'Система',
  'theme.tooltip': 'Тема',
};
